export default "__VITE_ASSET__oGf94A8j__"